export default {
	欢迎回来: 'おかえり',
	设置密码: 'パスワードを設定する',
}
